// import { getMyGemService } from "@/services";
export const terminology = {
  namespaced: true,
  state: {
    savedSingleUserConnections: {},
    terminologies: {
      user: { singular: "User", plural: "Users", vowel: "an" },
      employee: { singular: "Employee", plural: "Employees", vowel: "an" },
      prospect: { singular: "Prospect", plural: "Prospects", vowel: "a" },
      vendor: { singular: "Vendor", plural: "Vendors", vowel: "a" },
      workOrder: { singular: "Work Order", plural: "Work Orders", vowel: "a" },
      customer: { singular: "Customer", plural: "Customers", vowel: "a" },
      category: { singular: "Category", plural: "Categories", vowel: "a" },
      type: { singular: "Type", plural: "Types", vowel: "a" },
      warehouseLocation: {
        singular: "Warehouse Location",
        plural: "Warehouse Locations",
        vowel: "a",
      },
      event: { singular: "Event", plural: "Events", vowel: "an" },
      task: { singular: "Task", plural: "Tasks", vowel: "a" },
      automatedTask: { singular: "Automated Task", plural: "Automated Tasks", vowel: "an" },
      job: { singular: "Job", plural: "Jobs", vowel: "a" },
      status: { singular: "Status", plural: "Status", vowel: "a" },
      method: { singular: "Method", plural: "Methods", vowel: "a" },
      term: { singular: "Term", plural: "Terms", vowel: "a" },
      tax: { singular: "Tax", plural: "Tax", vowel: "a" },
      email: { singular: "Email", plural: "Emails", vowel: "a" },
      emailTemplate: {
        singular: "Email Template",
        plural: "Email Templates",
        vowel: "an",
      },
      emailSignature: {
        singular: "Email Signature",
        plural: "Email Signatures",
        vowel: "an",
      },
      sentEmail: {
        singular: "Sent Email",
        plural: "Sent Email",
        vowel: "a",
      },
      message: { singular: "Message", plural: "Messages", vowel: "a" },
      schedule: { singular: "Schedule", plural: "Schedules", vowel: "a" },
      invoiceBuilder: {
        singular: "Invoice Builder",
        plural: "Invoice Builders",
        vowel: "an",
      },
      notification: {
        singular: "Notification",
        plural: "Notifications",
        vowel: "a",
      },
      messageTemplate: {
        singular: "Message Template",
        plural: "Message Templates",
        vowel: "a",
      },
      account: { singular: "Chart of Account", plural: "Accounts", vowel: "a" },
      testingmodule: { singular: "Testing Module", plural: "Testing Modules", vowel: "a" },
      layout: { singular: "Layout", plural: "Layouts", vowel: "a" },
      service: { singular: "Service", plural: "Service", vowel: "a" },
      good: { singular: "Good", plural: "Good", vowel: "a" },
      discount: { singular: "Discount", plural: "Discount", vowel: "a" },
      invoice: { singular: "Invoice", plural: "Invoices", vowel: "an" },
      fixAsset: { singular: "Fix Asset", plural: "Fix Assets", vowel: "a" },
      permission: { singular: "Permission", plural: "Permissions", vowel: "a" },
      gems: { singular: "GEM", plural: "GEMs", vowel: "a" },
      estimates: { singular: "Estimate", plural: "Estimates", vowel: "an" },
      file: { singular: "file", plural: "files", vowel: "an" },
      deposit: { singular: "Deposit", plural: "Deposits", vowel: "a" },
      check: { singular: "Check", plural: "Checks", vowel: "a" },
      texteditor: { singular: "Text", plural: "Texts", vowel: "a" },
      warehouse: { singular: "Warehouse", plural: "Warehouses", vowel: "a" },
      bill: { singular: "Bill", plural: "Bills", vowel: "a" },
      credit: { singular: "Credit", plural: "Credits", vowel: "a" },
      tbe: { singular: "To Be Enter", plural: "To Be Entered", vowel: "a" },
      tba: { singular: "To Be Approve", plural: "To Be Approved", vowel: "a" },
      viewJournal: {
        singular: "Viewing Journal",
        plural: "Viewing Journal",
        vowel: "a",
      },
      returnItem: {
        singular: "Return Item",
        plural: "Return Items",
        vowel: "a",
      },
      payroll: {
        singular: "Payroll item",
        plural: "Payroll items",
        vowel: "a",
      },

      fundReceived: {
        singular: "Customer Payment",
        plural: "Funds Received",
        vowel: "a",
      },

      creditMemo: {
        singular: "Credit Memo",
        plural: "Credit Memos",
        vowel: "a",
      },

      salesReciept: {
        singular: "Sales Reciept",
        plural: "Sales Reciepts",
        vowel: "a",
      },
      purchaseOrder: {
        singular: "Purchase Order",
        plural: "Purchase Orders",
        vowel: "a",
      },

      customFields: {
        singular: "Custom Field",
        plural: "Custom Fields",
        vowel: "a",
      },

      otherCharge: {
        singular: "Other Charge",
        plural: "Other Charge",
        vowel: "a",
      },
      inventoryItem: {
        singular: "Inventory Item",
        plural: "Inventory Items",
        vowel: "an",
      },

      otherContact: {
        singular: "Other Contact",
        plural: "Other Contact",
        vowel: "an",
      },
      journalEntry: {
        singular: "Journal Entry",
        plural: "Journal Entries",
        vowel: "a",
      },
      privateContact: {
        singular: "Private Contact",
        plural: "Private Contacts",
        vowel: "a",
      },
      checkLayout: {
        singular: "Check Layout",
        plural: "Check Layouts",
        vowel: "a",
      },
      printCheck: {
        singular: "Print Check",
        plural: "Print Checks",
        vowel: "a",
      },
    },
  },
  actions: {
    async fetch({ commit }, payload) {
      let service = getMyGemService(serviceId);
      // return await service.all(data).then(
      //   (payload) => {
      //     commit("FETCH", { payload, service });
      //     commit("loadingStatus", true);
      //     return Promise.resolve(payload);
      //   },
      //   (error) => {
      //     commit("FETCH");
      //     return Promise.reject(error);
      //   }
      // );
    },
    async update({ commit },  data) {
      commit("UPDATE", data);
      return Promise.resolve(data);
    },
  },

  mutations: {
    FETCH(state, types) {
      state.savedSingleUserConnections = types;
    },
    UPDATE(state, data) {
   
      if (data) {
        state.terminologies[data.domain] = data.info;
      }
    },
  },
};
